export default __webpack_public_path__ + "static/media/Copy.4a602dcf.svg";